import { apiGet } from '@/network/api-client';

export interface Achievement {
  id: string;
  title: string;
  description: string;
  conditionType: string;
  conditionValue: number;
  rewardType: string;
  rewardAmount: number;
  unlocked: boolean;
  unlockedAt?: string;
}

export async function getAchievements(telegramId?: number): Promise<Achievement[]> {
  const query = telegramId != null ? `?telegramId=${telegramId}` : '';
  return apiGet<Achievement[]>(`/hero/achievements${query}`);
}
